import {useSelector} from 'react-redux'
import type {reduxProps} from '../constants'

const B2B_STAFF_ROLE_ID = 24

export function EducationLogo({placement}: {placement: 'aside' | 'header' | 'auth'}) {
  const {roleId, staffInfo} = useSelector((state: reduxProps) => state.authReducer)
  // Organization branding also applies to K12 accounts with a general education role.
  const isB2B = staffInfo.businessModel === 'b2b' ||
    (staffInfo.businessModel !== 'b2c' && Number(roleId) === B2B_STAFF_ROLE_ID)
  const className = placement === 'aside' ? 'aside-brand-mark' : placement === 'auth' ? 'auth-brand-mark' : 'h-30px logoKidly'

  if (placement !== 'auth' && isB2B) {
    return <img src={`${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/media/logos/logo.svg`} alt='Okudemi by Kidly' className={className}/>
  }

  if (placement !== 'header') {
    return <svg className={className} viewBox='339 327 2872 706' role='img' aria-label='Kidly Okul'>
      <image href={require('../_metronic/assets/img/logo.png')} width='3508' height='1243'/>
    </svg>
  }

  return <img src={require('../_metronic/assets/img/logo.png')} alt='Kidly Okul' className={className}/>
}
